import { breakpoints, IconRegularInfo, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const Wrapper = styled.div`
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  border-bottom: 1px solid ${theme.color.border.divider};

  svg {
    vertical-align: unset;
  }

  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
    gap: 2rem;
  }
`;

export const ReviewStats = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  align-items: center;

  @media (min-width: ${breakpoints.md}) {
    flex-direction: column;
    align-items: start;
    flex-basis: 240px;
    flex-grow: 0;
    flex-shrink: 0;
  }
`;

export const Username = styled.div`
  ${theme.typography.labelSmall}

  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.labelRegular}
  }
`;

export const SecondaryText = styled.div`
  ${theme.typography.labelSmall400}
  color: ${theme.color.text.secondary};

  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.labelRegular400}
  }
`;

export const TitleText = styled.div`
  ${theme.typography.labelLarge}
  color: ${theme.color.text.primary};

  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.titleSmall}
    font-size: 18px;
    margin-bottom: 0.75rem;
  }
`;

export const ReviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const TitleAndVariantAndTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (min-width: ${breakpoints.md}) {
    gap: 0.75rem;
  }
`;

export const ReviewText = styled.div`
  ${theme.typography.bodyRegular}

  width: 100%;
  word-break: break-word;

  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.bodyLarge}
  }
`;

export const ThumbsUpDownWrapper = styled.div`
  margin-left: 1rem;
  display: flex;
  gap: 0.75rem;

  svg {
    color: ${theme.color.icon.secondary};
    width: 14px;
    height: 14px;
  }

  @media (min-width: ${breakpoints.md}) {
    svg {
      width: 16px;
      height: 16px;
    }
  }

  > button {
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
    display: flex;
    gap: 0.25rem;
    align-items: center;
    user-select: none;
  }
`;

export const StyledIconRegularInfo = styled(IconRegularInfo)`
  vertical-align: unset;
`;

export const ImagesWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;

  @media (min-width: ${breakpoints.md}) {
    flex-wrap: wrap;
  }

  button {
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
    border-radius: 4px;
  }

  button > img {
    height: 80px;
    width: 80px;
    min-width: 80px;
    object-fit: cover;
    border-radius: 4px;
  }
`;
